import { Howl, Howler } from 'howler'
import { sample } from '@/js/utils'
import store from '@/store'

const enemies_slugs = [ 'eyes', 'fire', 'gargoyle', 'leaf', 'tentacle', 'tongue', 'vampire', 'dragon', 'king', 'pigeon' ]


const Sounds = {
	elements: [],
	playings: [],
	// volume: 0.5 / 1.5,

	async init() {
		// console.log(require('@/assets/sounds/hit/hit-1.wav'))
		let start = Date.now()
		let loaded = []
		const files = require.context('@/assets/sounds/', true, /^.*\.wav|.*\.ogg$/).keys()
		for (let id in files) {
			let slug = files[id].substr(2).replace('.wav', '').replace('.ogg', '')
			const folder = slug.split('/')[0]

			let volume = 1
			// if (folder === 'hit') volume = 0.8
			// else if (folder === 'attack') volume = 0.8
			if (enemies_slugs.includes(folder)) volume = 0.5
			
			const url = require('@/assets/sounds/' + files[id].substr(2))
			// urls.push(url)

			this.elements.push({
				slug,
				folder,
				howl: new Howl({
					src: [ url ],
					volume: volume,
					onend: () => {
						const index = this.playings.findIndex(p => p.slug === slug)
						if (index > -1) this.playings.splice(index, 1)
					},
					onload: () => {
						loaded.push(url)
						if (loaded.length === files.length) store.commit('SET_LOADED', { sounds: true })
					}
				})
			})
		}
		
		console.info(this.elements.length + ' sounds loaded in ' + (Date.now() - start) + 'ms')
	},

	play(slug) {
		// if (this.volume) {
			const time = Math.trunc(Date.now() / 20)
			if (!this.playings.find(p => p.slug === slug && p.time === time)) {
				let elements = this.elements.filter(e => e.folder === slug)
				if (!elements) elements = [ this.elements.filter(e => e.slug === slug) ]
				if (elements.length) {
					sample(elements).howl.play()
					this.playings.push({ slug, time })
				}
			}
		// }
	},

	set_volume(volume) {
		// this.volume = volume / 1.5
		// this.elements.forEach((element) => {
		// 	element.howl.volume(volume / 1.5)
		// })
		Howler.volume(volume)
	},

	mute(mute) {
		Howler.mute(mute)
	}

}

export default Sounds